import React, { Component } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { far } from "@fortawesome/pro-regular-svg-icons"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { StyledIcon } from "./partials"

library.add(fal, far, fas, fab)

class IconV2 extends Component {
  render() {
    const getIcon = (icon) => {
      switch (icon) {
        case "fa-twitter":
          return "fa-x-twitter"
        case "fa-facebook":
          return "fa-square-facebook"
        case "fa-linkedin":
          return "fa-linkedin-in"
        default:
          return icon
      }
    }

    return (
      <StyledIcon
        color={this.props.color ? this.props.color : ""}
        size={this.props.size ? this.props.size : "18"}
      >
        <FontAwesomeIcon
          icon={[
            this.props.iconType ? this.props.iconType : "far",
            this.props.loading ? "spinner" : getIcon(this.props.icon),
          ]}
          className={this.props.loading ? "fa-spin" : ""}
        />
      </StyledIcon>
    )
  }
}

export default IconV2
